export class LowercaseMask {
  static transform(value: string | null) {
    return (value || '').toLowerCase();
  }
}
